import {useState} from "react";
import toast from "react-hot-toast";
import {toastDefs, toastDefsError} from '../../../../config/toastConfig';
import {useAuth} from "../../../../contexts/UserContext";
import api from "../../../../services/api";
import {comum} from "../../../../styles/Themes/light";
import ModalDefault from "../../../ModalDefault";
import {ModalContactHead} from "../../../SearchProfessionalProposal/styles";
import ButtonDefault from "../../../form/ButtonDefault";
import InputMoney from "../../../form/InputMoney";
import {IconAdvanceMoney, IconAttachment, IconClose, IconEdit, IconInstruction} from "../../../icons";
import {ModalButtons, ModalPendenciesType, ModalWrapper} from "./styles";


const tiposPendencias: any = {
    correcao: {
        texto: 'Descreva a alteração necessária:',
        tipo: 'correcao',
        icon: <IconEdit color={comum.colors.primaryRed400}/>,
        label: 'Correção',
        user: 'Operador',
        pagmento: false
    },
    informacao: {
        texto: 'Descreva a instrução necessária:',
        tipo: 'informacao',
        icon: <IconInstruction color={comum.colors.primaryRed400}/>,
        label: 'Informação',
        user: 'comum',
        pagmento: false
    },
    orientacao: {
        texto: 'Descreva a orientação:',
        tipo: 'orientacao',
        icon: <IconInstruction color={comum.colors.primaryRed400}/>,
        label: 'Orientação',
        user: 'comum',
        pagmento: false
    },
    documentacao: {
        texto: 'Descreva a solicitação:',
        tipo: 'documentacao',
        icon: <IconAttachment color={comum.colors.primaryRed400}/>,
        label: 'Documentação',
        user: 'comum',
        pagmento: false
    },
    marjoracao: {
        texto: 'Descreva a majoração:',
        tipo: 'marjoracao',
        icon: <IconAdvanceMoney color={comum.colors.primaryRed400}/>,
        label: 'Majoração',
        user: 'comum',
        pagmento: true
    },
    reembolso: {
        texto: 'Descreva o reembolso:',
        tipo: 'reembolso',
        icon: <IconAdvanceMoney color={comum.colors.primaryRed400}/>,
        label: 'Reembolso',
        user: 'comum',
        pagmento: true
    },
    adiantamento: {
        texto: 'Descreva o adiantamento:',
        tipo: 'adiantamento',
        icon: <IconAdvanceMoney color={comum.colors.primaryRed400}/>,
        label: 'Adiantamento',
        user: 'comum',
        pagmento: true
    },
    s_informacao: {
        texto: 'Descreva a solicitação para o operador:',
        tipo: 's_informacao',
        icon: <IconInstruction color={comum.colors.primaryRed400}/>,
        label: 'Solicitação',
        user: 'Solicitante',
        pagmento: false
    }
}

export default function ModalPendenciaAdicionar({
    modalAtivo, setModalAtivo, 
    tipoPendencia, setTipoPendencia,
    setUpdate,
    pagamento,
    id_proposta
}: {
    modalAtivo: boolean,
    setModalAtivo: (modalAtivo: boolean) => void,
    tipoPendencia: string,
    setTipoPendencia: (tipoPendencia: string) => void,
    setUpdate: (update: any) => void,
    pagamento: boolean,
    id_proposta: string
}) {
    const { user } = useAuth();
    const [ justificativa, setJustificativa ] = useState<any>();
    const [ valor, setValor ] = useState<any>();
    const [ solicitando, setSolicitando ] = useState<boolean>(false)

    function tostaSucesso() {
        toast.success('Pendência criada com sucesso', toastDefs);
    }

    async function createPendency() {
        try {
            setSolicitando(true)

            if (tipoPendencia) {
                const pendencia = {
                    id_proposta: id_proposta,
                    tipo: tipoPendencia,
                    descricao: justificativa,
                    valor: valor
                }
                const response = await api.post('/pendencia', pendencia);
                if (response.data.status !== 'success') {
                    setSolicitando(false)
                    if (response.data.result[0] === undefined) {
                        throw new Error(response.data.message);
                    } else {
                        throw new Error(response.data.result[0].error);
                    }
                } else {
                    setSolicitando(false)
                    setModalAtivo(false);
                    setTipoPendencia('');
                    setUpdate(new Date());
                    tostaSucesso();
                }
            }
        } catch (error: any) {
                    setSolicitando(false)
            toast.error(error.message, toastDefsError);
            
        }
    }
    function handleOnChangePendencyMoney(value: string) {
        setValor(value);
    }
    return (
    <ModalDefault
        id={'overlayModal'}
        onClose={() => setModalAtivo(!modalAtivo)}
        openModal={modalAtivo}
        width="fit-content"
    >
        <ModalContactHead>
            <div>
                Adicionar pendência
            </div>

            <div
                className="close-pendencie"
                onClick={() => { setTipoPendencia(''); setModalAtivo(false)}}
            >
                <IconClose />
            </div>
        </ModalContactHead>
        
        <ModalWrapper>

            {
                tipoPendencia === '' &&
                <ModalPendenciesType>
                    {
                        Object.values(tiposPendencias).map((pendencia: any) => (
                            (
                                (pendencia.user === user.profile) &&
                                (pagamento === pendencia.pagmento)
                            ) &&
                            <div 
                                className="type"
                                onClick={() => setTipoPendencia(pendencia.tipo)}
                            >
                                {pendencia.icon}
                                {pendencia.label}
                            </div>
                        ))
                    }
                </ModalPendenciesType>
            }

            {
                tipoPendencia !== '' &&
                <ModalPendenciesType>
                    <div
                        className="show-type"
                    >
                        {tiposPendencias[tipoPendencia].icon}
                        {tiposPendencias[tipoPendencia].label}
                    </div>

                    {
                        tiposPendencias[tipoPendencia].pagmento &&
                            <div className="value">
                                <span>Valor:</span>
                                <div className="price">
                                    <InputMoney
                                        name="from"
                                        placeholder="R$ 0,00"
                                        value=""
                                        onChangeText={handleOnChangePendencyMoney}
                                        className='small'
                                    />
                                </div>
                            </div>
                    }

                    <div className="description">
                        <span>{tiposPendencias[tipoPendencia].texto}</span>

                        <div className="text">
                            <textarea
                                name="justify"
                                id="1"
                                className="text-area"
                                onChange={(e) => setJustificativa(e.target.value)}
                            />
                        </div>
                    </div>
                </ModalPendenciesType>
            }

            {
                tipoPendencia !== '' &&
                <ModalButtons>

                    <ButtonDefault
                        className="cancel"
                        onClick={() => setTipoPendencia('')}
                    >
                        Voltar
                    </ButtonDefault>
                    <ButtonDefault
                        className="continue"
                        disabled={(justificativa === undefined || solicitando) ? true : false}
                        onClick={createPendency}
                    >
                    {!solicitando ? `Solicitar` : `Solicitando...`}

                    </ButtonDefault>

                </ModalButtons>
            }
        </ModalWrapper>
    </ModalDefault>
    );
}
